import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Injectable,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { includes } from 'lodash';
import { Alert, Evaluation } from 'src/app/alerts/models/alert.interface';
import { ToastService } from 'src/app/shared/services/toast.service';
import { OperatorService } from 'src/app/shared/services/operator.service';
import { WhatsappService } from '../../services/whatsapp.service';
import { AlertService } from 'src/app/alertas/services/alert.service';
import { UserDataService } from 'src/app/profile-config/services/user-data.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ResponseInterface } from 'src/app/core/interfaces/response-interface';
import { EvaluationCriteria, WhatsAppResponse } from '../../models/interfaces';
import { EvaluationCriteriaService } from '../../services/evaluation-criteria.service';
import { MapAsideService } from 'src/app/panel/components/map-aside/service/map-aside.service';
import { NgZone } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
@Component({
  selector: 'app-event-evaluation',
  templateUrl: './event-evaluation.component.html',
  styleUrls: ['./event-evaluation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventEvaluationComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @Input() event: any;
  @Input() loading_evaluation: boolean = true;
  @Input() evaluation_criteria_filter: any[] = [];
  @Input() submitting: boolean = false;
  @Input() evaluation_criteria: any[] = [];
  @Input() eventsEvaluated: number = 0;
  @Output() submitEvaluation = new EventEmitter<{
    evaluation: Evaluation;
    event: Alert;
  }>();
  @Output() closeEvaluationExpanded = new EventEmitter<{
    evaluation: Evaluation;
  }>();
  @Output() submitSendEvaluationByWhatsapp = new EventEmitter<{
    EvaluationByWhatsapp: boolean;
  }>();
  @Output() submitSendExternal = new EventEmitter<{
    External: boolean;
  }>();
  @ViewChild('submitEvaluationButton') submitEvaluationButton!: ElementRef;
  monitoringOperatorTemp: string = '';
  evaluationObservationsTemp: string[] = [];
  evaluationObservations: string[] = [];
  evaluationCriteria: any[] = [];
  showDialog: boolean = true; //controla si p-dialog se muestra
  showDialogContent: boolean = true; //controla si contenido de p-dialog se muestra
  expandedRows: { [s: string]: boolean } = {};
  sendEvaluationByWhatsapp: boolean = false;
  sendExternal: boolean = false;
  imeiBelongsToAntapaccayAccount: boolean = false;
  confirmedJudgingEvent: boolean = false;
  whatsappsSendingMessage: string = '';
  messagesSentByWhatsApp: WhatsAppResponse[] = [];
  isCriteriaConfirmed: boolean = false;

  idCriteriosSelected?: string;
  // Variables para Linea
  checkEvent: string[] = [
    'exceso-velocidad',
    'infraccion-geocerca-direccion',
    'infraccion-geocerca',
    'exceso-velocidad-geocerca-direccion',
    'conductor-somnoliento-360',
    'conductor-adormitado-360',
    'posible-fatiga',
  ];
  //
  operators = [
    {
      label: 'Operadores',
      items: [
        {
          label: 'ATENCIO ALFARO, Claudia Isabel',
          value: 'ATENCIO ALFARO, Claudia Isabel',
        },
        {
          label: 'FERNANDEZ CRUZ, Rosellia Yanina',
          value: 'FERNANDEZ CRUZ, Rosellia Yanina',
        },
        {
          label: 'HAÑARI SALCEDO, Katherine Liliana',
          value: 'HAÑARI SALCEDO, Katherine Liliana',
        },
        { label: 'MAMANI SIERRA, Raquel', value: 'MAMANI SIERRA, Raquel' },
        {
          label: 'NUÑEZ CHAMBI, Michelle Solzire',
          value: 'NUÑEZ CHAMBI, Michelle Solzire',
        },
        {
          label: 'NUÑONCA ALARCON, Daniela Stefany',
          value: 'NUÑONCA ALARCON, Daniela Stefany',
        },
        {
          label: 'PACCI QUISPE, Betzy Belquis',
          value: 'PACCI QUISPE, Betzy Belquis',
        },
        {
          label: 'PACHECO MOLLO, Cesar Vidal',
          value: 'PACHECO MOLLO, Cesar Vidal',
        },
        {
          label: 'ROJAS RONDON, Carla Beatriz',
          value: 'ROJAS RONDON, Carla Beatriz',
        },
        {
          label: 'SUARES PACURI, Ayelen Melani',
          value: 'SUARES PACURI, Ayelen Melani',
        },
      ],
    },
  ];

  msmOfTxRadial: string = 'Sin Respuesta';
  isMapAsideOpen$ = this.mapAsideService.isHidden$;
  private onDestroy$ = new Subject<boolean>();
  constructor(
    public evaluationCriteriaService: EvaluationCriteriaService,
    private toastService: ToastService,
    public operatorService: OperatorService,
    private whatsappService: WhatsappService,
    private alertService: AlertService,
    private userDataService: UserDataService,
    private http: HttpClient,
    private mapAsideService: MapAsideService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) {}
  withCriterios = false;
  msmOfTxRadialChange(event: any) {
    const value = event.value;
    if (value == null) this.msmOfTxRadial = 'Sin respuesta';
    if (value == true) this.msmOfTxRadial = 'Si';
    if (value == false) this.msmOfTxRadial = 'No';
  }
  msmOfTxRadialSelect(value: boolean | null | undefined): string {
    if (value == null) this.msmOfTxRadial = 'Sin respuesta';
    if (value == true) this.msmOfTxRadial = 'Si';
    if (value == false) this.msmOfTxRadial = 'No';
    return this.msmOfTxRadial;
  }
  ngOnInit(): void {
    if (
      this.evaluation_criteria_filter &&
      this.evaluation_criteria_filter.length > 0
    ) {
      this.withCriterios = true;
    }
    this.monitoringOperatorTemp =
      localStorage.getItem('monitoringOperator') ?? '';
    this.eventsEvaluated < 6
      ? (this.submitting = false)
      : (this.submitting = true);
    this.evaluationObservationsTemp = JSON.parse(
      localStorage.getItem('evaluationObservations') || '[]'
    );

    this.operators = this.operatorService.listOperators;
    this.vehicleIsFromAntapaccay(this.event.imei);
    this.messageSendingMessage();

    /* this.mapAsideService.submitFormEventContent$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(({ body, event }) => {
        if (body !== undefined && event !== undefined) {
          this.submitEvaluationEmiter(body, event);
          this.mapAsideService.setSubmitFormEventContent(undefined, undefined);
        }
      }); */

    /* this.mapAsideService.sendEvaluationByWhatsapp$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((state) => {
        this.sendEvaluationByWhatsapp = state;
        this.submitSendEvaluationByWhatsappEmitter();
      });

    this.mapAsideService.sendExternal$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((state) => {
        this.sendExternal = state;
        this.submitSendExternalEmitter();
      }); */
  }
  ngOnDestroy(): void {
    /* localStorage.setItem('monitoringOperator', this.monitoringOperatorTemp);
    localStorage.setItem(
      'evaluationObservations',
      JSON.stringify(this.evaluationObservationsTemp)
    ); */
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }
  ngAfterViewInit(): void {
    try {
      // Verificar si event y evaluations existen
      if (!this.event?.evaluations) {
        console.warn('No hay evaluaciones disponibles');
        return;
      }
      // Verificar si evaluations es un objeto o un array
      if (Array.isArray(this.event.evaluations)) {
        // Si es un array, iteramos directamente
        this.event.evaluations.forEach((e: any) => {
          if (e && typeof e === 'object') {
            e.operador_monitoreo = this.monitoringOperatorTemp;
          }
        });
      } else if (typeof this.event.evaluations === 'object') {
        // Si es un objeto, usamos Object.values
        Object.values(this.event.evaluations).forEach((e: any) => {
          if (e && typeof e === 'object') {
            e.operador_monitoreo = this.monitoringOperatorTemp;
          }
        });
      }
    } catch (error) {
      console.warn('Error al procesar evaluaciones:', error);
    }
  }

  checkListEventsByType(type: string) {
    return this.checkEvent.includes(type);
  }
  onHide() {
    this.showDialog = true;
    this.showDialogContent
      ? (this.showDialogContent = false)
      : (this.showDialogContent = true);
    // console.log('event evaluation dialog', this.event);
  }

  criteriaSelected(event: any, evaluation: any) {
    this.ngZone.run(() => {
      evaluation.criterion_id = event.value;
      evaluation.criterio_evaluacion = event.originalEvent.target.innerText;
      evaluation.is_confirmed =
        this.evaluationCriteriaService.isCriteriaConfirmed(
          evaluation.criterion_id
        );

      evaluation.senales_posible_fatiga =
        this.evaluationCriteriaService.isPosibleFatiga(event.value);

      this.cdr.detectChanges();
    });
  }
  criteriaSelectedFromAutoComplete(event: any, evaluation: any) {
    this.ngZone.run(() => {
      evaluation.criterion_id = event.value;
      evaluation.criterio_evaluacion = event.label;

      evaluation.senales_posible_fatiga =
        this.evaluationCriteriaService.isPosibleFatiga(event.value);
      evaluation.is_confirmed =
        this.evaluationCriteriaService.isCriteriaConfirmed(
          evaluation.criterion_id
        );

      this.evaluationCriteria.some((c, i) => {
        if (i < 2 && c.label == event.label) {
          this.confirmedJudgingEvent = true;
          return true;
        }
        this.confirmedJudgingEvent = false;
        return false;
      });
      // console.log('CONFIRMED JUDGING EVENT: ', this.confirmedJudgingEvent);

      this.cdr.detectChanges();
    });
  }

  private assignCriteriaToEvaluation(evaluationCriteria : EvaluationCriteria, evaluation : any){
    evaluation.criterion_id = evaluationCriteria.id;
    evaluation.criterio_evaluacion = evaluationCriteria.name;
    evaluation.is_confirmed = this.evaluationCriteriaService.isCriteriaConfirmed(evaluationCriteria.id);
    evaluation.senales_posible_fatiga = this.evaluationCriteriaService.isPosibleFatiga(evaluationCriteria.id)
  }


  submitEvaluationEmiter(evaluation: any, event: Alert) {
    this.ngZone.run(() => {
      /* evaluation.is_confirmed =
        this.evaluationCriteriaService.isCriteriaConfirmed(
          evaluation.criterion_id
        ); */

      this.monitoringOperatorTemp = evaluation.operador_monitoreo ?? '';
      if (evaluation.observacion_evaluacion?.length! > 3) {
        this.evaluationObservationsTemp.find(
          (e) => e == evaluation.observacion_evaluacion
        )
          ? null
          : this.evaluationObservationsTemp.push(
              evaluation.observacion_evaluacion!
            );
      }

      this.submitEvaluation.emit({ evaluation, event });
    });
  }

  closeEvaluationExpandedEmiter(evaluation: Evaluation) {
    this.ngZone.run(() => {
      this.closeEvaluationExpanded.emit({ evaluation });
    });
  }
  submitSendEvaluationByWhatsappEmitter() {
    this.ngZone.run(() => {
      let EvaluationByWhatsapp = this.sendEvaluationByWhatsapp;
      this.submitSendEvaluationByWhatsapp.emit({ EvaluationByWhatsapp });
    });
  }
  submitSendExternalEmitter() {
    this.ngZone.run(() => {
      let External = this.sendExternal;
      this.submitSendExternal.emit({ External });
    });
  }
  saveEvaluationOnShiftEnter() {
    this.ngZone.run(() => {
      this.submitEvaluationButton.nativeElement.click();
    });
  }
  searchEvaluationObservationsTemp(event: any) {
    this.ngZone.run(() => {
      let filtered: any[] = [];
      let q = event.query;
      this.evaluationObservationsTemp.forEach((e) => {
        e.toLowerCase().includes(q.toLowerCase()) ? filtered.push(e) : null;
      });
      this.evaluationObservations = filtered;
      this.cdr.detectChanges();
    });
  }
  // searchEvaluationCriteria(event: any) {
  //   let filtered: any[] = [];
  //   let q = event.query.toLowerCase(); // Convertir la consulta a minúsculas y eliminar espacios en blanco

  //   this.evaluation_criteria_filter.forEach((e) => {
  //     let matchedItems: any[] = e.items.filter(
  //       (i: { label: string; value: string }) => {
  //         // Filtrar los items que coincidan con la consulta
  //         return (
  //           i.label.toLowerCase().includes(q) ||
  //           i.value.toLowerCase().includes(q)
  //         );
  //       }
  //     );

  //     if (matchedItems.length > 0) {
  //       // Si hay elementos coincidentes, agregarlos al objeto filtrado
  //       filtered.push({
  //         label: e.label,
  //         items: matchedItems,
  //       });
  //     }
  //   });
  //   // console.log('eventEval: filtered', filtered);

  //   this.evaluationCriteria = [...filtered];
  // }
  searchEvaluationCriteria(event: any) {
    this.ngZone.run(() => {
      let filtered: any[] = [];
      let q = event.query.toLowerCase(); // Convertir la consulta a minúsculas y eliminar espacios en blanco
      this.evaluation_criteria_filter.forEach((e) => {
        //filtered.push(e.label);
        e.items.filter((i: { label: string; value: string }) => {
          i.label.toLowerCase().includes(q) ? filtered.push(i) : null;
        });
      });
      // console.log('eventEval: filtered', filtered);

      this.evaluationCriteria = [...filtered];
      this.cdr.detectChanges();
    });
  }
  iCanSeeExternalSending(): boolean {
    let res: boolean = false;
    const a: any = this.alertService.getAlertById(
      this.event.evento_id.toString()
    );
    if (
      a &&
      this.imeiBelongsToAntapaccayAccount &&
      this.confirmedJudgingEvent
    ) {
      res = true;
    }
    return res;
  }
  iCanSeeWhatsappSending(): boolean {
    let res: boolean = false;
    const a: any = this.alertService.getAlertById(
      this.event.evento_id.toString()
    );
    if (
      a &&
      a.notificacion_whatsapp &&
      this.checkBoolean(a.notificacion_whatsapp) &&
      this.imeiBelongsToAntapaccayAccount &&
      this.confirmedJudgingEvent
    ) {
      res = true;
    }
    return res;
  }
  private checkBoolean(input: string | number | boolean): boolean {
    if (typeof input === 'boolean') {
      return input;
    }
    const booleanValues: Record<string, boolean> = {
      true: true,
      false: false,
      '1': true,
      '0': false,
    };
    if (typeof input === 'number') {
      return booleanValues[input.toString()] ?? false;
    }
    if (typeof input === 'string') {
      const trimmedInput = input.trim().toLowerCase();
      return booleanValues[trimmedInput] ?? false;
    }
    return false;
  }
  isUserManager961(): boolean {
    let id_user_manager = this.userDataService.userData;
    return id_user_manager !== null && id_user_manager === 961;
  }
  private vehicleIsFromAntapaccay(imei: string) {
    this.imeiBelongsToAntapaccayAccount =
      this.whatsappService.IMEIsBelongsToAntapaccayAccount.some(
        (_: string) => _ == imei
      );
  }
  messageSendingMessage() {
    if (!this.event.evaluations[0]) {
      return;
    }

    let messages: Record<string, (T: WhatsAppResponse[]) => string> = {
      false: (T) => {
        if (T.length > 0) {
          return 'Algunos mensajes de WhatsApp no se enviaron.';
        } else {
          return ''; // 'No se enviaron mensajes de WhatsApp.';
        }
      },
      true: (T) => 'Los mensajes de WhatsApp se enviaron correctamente.',
    };

    this.whatsappService
      .getMessagesSentByWhatsApp(
        this.event.evaluations[0].usuario_id,
        this.event.evaluations[0].uuid_event
      )
      .then((r) => {
        this.ngZone.run(() => {
          this.messagesSentByWhatsApp = r;
          this.whatsappsSendingMessage =
            messages[`${this.areMessagesSentCorrectly()}`](r);
          this.cdr.detectChanges();
        });
      })
      .catch((r) => {});
  }
  areMessagesSentCorrectly(): boolean {
    return this.messagesSentByWhatsApp.some((r) => r.status == 200);
  }
  getNumberOfSentByWhatsApp(T: WhatsAppResponse[]): string {
    return Object.entries(T)
      .filter(([_, wr]) => wr.status != 200)
      .map(([_, wr]) => wr.phone)
      .join(', ');
  }
}
